import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { recaptcha } from '../../../../utilities/recaptcha/recaptcha';
import FileInput from '../../../Shared/FileInput/FileInput';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { MessageContent, PopUp, EnumStep } from '../General';
import { UploadUsersList, setShowPopUp, setCurrentStep, setActionType } from '../OrgUsersManagementSlice';
import InvalidFileLines from './InvalidFileLines';
import EpiContext from '@episerver/spa-core/Spa';
import { saveToHistory } from '../OrgUsersManagementSlice';
import { isMobile } from 'react-device-detect';

function UploadOrgUserList(props) {
  useEffect(() => {
    props.saveToHistory('UploadUsers');
  }, []);
  const initialFileData = {
    fileName: '',
    extension: '',
    fileInBase64: '',
  };
  const [fileData, setFileData] = useState({ initialFileData });
  const [fileError, setFileError] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');
  const [showInvalidLine, setShowInvalidLine] = useState(false);
  const [invalidLines, setInvalidLines] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isDragging, setDragging] = useState(false);
  const upgradeOrActivate = props.actionType;

  const validExtensions = props.iContent.extensions.value.split(',');
  const maxSizeFileKb = props.iContent.fileSize.value;
  const needsActionTypeSelection = props.allowActivate && props.allowUpgrade;

  useEffect(() => {
    if(props.allowActivate && props.allowUpgrade) {
      props.setActionType('');
    } else if (!props.allowActivate && props.allowUpgrade){
      props.setActionType('upgrade');
    } else if (props.allowActivate && !props.allowUpgrade) {
      props.setActionType('activate');
    }
  }, []);
  


  async function uploadFile(file) {
    let fileConverted = await toBase64(file);
    let extension = file.type.split('/')[1];
    let fileSizeInKb = file.size / 1000;
    if (!validExtensions.includes(extension)) setFileError('הפורמט של הקובץ אינו תקין');
    if (fileSizeInKb > maxSizeFileKb) setFileError('אנא טען קובץ בגודל מתאים');

    setFileData({
      ...fileData,
      fileName: file.name.split('.')[0],
      extension,
      fileInBase64: fileConverted.replace(`data:${file.type};base64,`, ''),
    });
  }

  const sendFile = async () => {
    setIsSubmit(true);
    if (needsActionTypeSelection && !props.actionType) {
      return;
    }
    if (fileData.fileName != '') {
      recaptcha().then(async (capchaValue) => {
        if (capchaValue != '' && capchaValue != null) {
          await props
            .UploadUsersList({
              extension: fileData.extension,
              fileInBase64: fileData.fileInBase64,
              capchaValue,
              fileName: fileData.filename,
              orgId: props.portalsBlock.selectedHetPay,
              actionType: props.actionType,
            })
            .then((res) => {
              if (res.payload.error) {
                props.setShowPopUp({ show: true, message: MessageContent.UploadFileError, type: PopUp.GeneralMessage });
              } else {
                if (res.payload.Body.invalidLineFileResponses?.length > 0) {
                  setInvalidLines(res.payload.Body.invalidLineFileResponses);
                  setShowInvalidLine(true);
                } else {
                  if (props.actionType == 'activate') {
                  props.setShowPopUp({ show: true, message: MessageContent.UploadFileSuccess, type: PopUp.GeneralMessage });
                  } else if (props.actionType == 'upgrade') {
                    props.setShowPopUp({ show: true, message: MessageContent.UploadFileSuccessUpgrade, type: PopUp.GeneralMessage });
                  }
                }
              }
            });
        }
      });
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const UploadNewFile = () => {
    setIsSubmit(false);
    setShowInvalidLine(false);
    setFileData({ ...initialFileData });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    setFileError('');
    uploadFile(e.dataTransfer.files[0]);
  };

  return (
    <div className='UploadOrgUserList'>
      {showInvalidLine ? (
        <InvalidFileLines invalidLineFile={invalidLines} UploadNewFile={UploadNewFile} upgradeOrActivate={upgradeOrActivate} />
      ) : (
        <>
          <div className='M_Title'> טעינת פרטי עובדים</div>
          <div className='S_Title'>
            העלו למערכת את פרטי העובדים הרלוונטיים
            <br />
            <span> מסמכים במשקל של עד {maxSizeFileKb}KB </span>
            <br />
            <span> בפורמט : {props.iContent.extensions.value}</span>
          </div>
          <div className='actionTypeSelect'>
            <label className='drop-down'>בחר סוג טעינה</label>
            <select
              className='drop-down-select'
              value={props.actionType}
              onChange={(e) => {
                const value = e.target.value;
                props.setActionType(value);
              }}>
              {props.allowActivate && props.allowUpgrade && <option value=''>בחר סוג טעינה</option>}
              {props.allowActivate && <option value='activate'>אקטוב</option>}
              {props.allowUpgrade && <option value='upgrade'>שדרוג</option>}
            </select>
          </div>

          {isMobile &&
            <div className='purpleText'> בשביל לראות סטאטוס מנויים שנטענו בעבר,
              יש להיכנס לתהליך דרך המחשב</div>}
          <div className='org-details'>
            <span className='org-name'> {props.portalsBlock.selectedOrgName} </span>
            <span className='org-id'> {props.portalsBlock.selectedHetPay} </span>
          </div>

          <div
            className='d-flex flex-column file_container'
            onDragOver={(e) => {
              e.preventDefault();
              setDragging(true);
            }}
            onDragLeave={() => setDragging(false)}
            onDrop={(e) => handleDrop(e)}>
            <FileInput
              id='fileInput'
              onChange={(e) => {
                uploadFile(e.target.files[0]);
                setFileError('');
              }}
              isDraggingOver={isDragging}
              filename={fileData.fileName}
              error={fileError}
              removeFile={() => {
                setFileData({ ...initialFileData });
              }}
            />
          </div>

          <div className='btn-container'>
            <BtnSubmit
              className='send-file-btn'
              text='שלח'
              onclick={() => {
                fileError == '' && sendFile();
              }}
            />
            {(props.usersList.length > 0 && !isMobile) && (
              <BtnSubmit
                className='white'
                text='חזרה לפורטל מנויים'
                onclick={() => {
                  props.setCurrentStep(EnumStep.PortalManagement);
                }}
              />
            )}
            <span className={`text ${isSubmit && needsActionTypeSelection && !props.actionType ? 'd-block' : 'd-none'}`}>אנא בחר סוג טעינה</span>
            <span className={`text ${isSubmit && !fileData.fileInBase64 && props.actionType ? 'd-block' : 'd-none'}`}>אנא בחר קובץ</span>
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    validationFile: state.SelfCareUploadFile,
    portalsBlock: state.portalsBlock,
    usersList: state.orgUsersManagement.usersList,
    actionType: state.orgUsersManagement.actionType,
  };
};

const mapDispatchToProps = {
  UploadUsersList,
  setShowPopUp,
  saveToHistory,
  setCurrentStep,
  setActionType,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadOrgUserList);
